import axios from 'axios';
import { getLeadOriginData } from '../utils/leadOrigin';

const API_URL = process.env.REACT_APP_BACKEND_API;
const ORIGIN_LEADS = "Probies";
const ORIGIN_STUDENTS = `${ORIGIN_LEADS} alunos`;
const HEADERS = {
  "Content-Type": "application/json",
};

export const saveLead = async (userContact) => {
  try {
    const { source, campaign, googleAdsCampaignId } = getLeadOriginData();
    
    const body = {
      name: userContact.name,
      position: userContact.position,
      email: userContact.email,
      department: userContact.department,
      phone: userContact.phone,
      segment: userContact.segment,
      company: userContact.company,
      employeesNumber: userContact.employeesNumber,
      comments: userContact.comments,
      origin: ORIGIN_LEADS,
      pageOrigin: source,
      campaign: campaign || undefined,
      gad_campaignid: googleAdsCampaignId || undefined,
      recaptchaToken: userContact.recaptchaToken,
      honeypotField: userContact.honeypot || "",
    };

    await axios.post(`${API_URL}/submit`, body,
      { headers: HEADERS }
    );
  } catch (error) {
    console.error("Error making request to backend", error);
    throw new Error(error instanceof Error ? error.message : "Unknown error");
  }
};

export const saveStudent = async (userContact) => {
  try {
    const { source, campaign, googleAdsCampaignId } = getLeadOriginData();
    
    const body = {
      name: userContact.name,
      email: userContact.email,
      phone: userContact.phone,
      comments: userContact.interestArea,
      origin: ORIGIN_STUDENTS,
      pageOrigin: source,
      campaign: campaign || undefined,
      gad_campaignid: googleAdsCampaignId || undefined,
      recaptchaToken: userContact.recaptchaToken,
      honeypotField: userContact.honeypot || "",
      company: "",
      companyBiggestPain: "",
      department: "",
      employeesNumber: "",
      position: "",
      segment: "",
    };

    await axios.post(`${API_URL}/submit`, body,
      { headers: HEADERS }
    );
  } catch (error) {
    console.error("Error making request to backend", error);
    throw new Error(error instanceof Error ? error.message : "Unknown error");
  }
};
